// Hands My hike lists' sort rules (hikeListSort.ts) to the page's inline script in
// app/views/users/hike_lists.html.erb, which calls `window.hikeListSort.apply` from its sort menu.

import { hikeListSortSelection, posthogSortAnalytics } from './hikeListSort'

window.hikeListSort = hikeListSortSelection(posthogSortAnalytics)
